import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import Configuration from "./pages/Configuration";
import Login from "./pages/Login";
import {ConfiguratorProvider} from "./context/ConfiguratorContext";
import {ToastContainer} from "react-toastify";
import ThankYouPage from "./pages/ThankYouPage";

import DealerConfiguration from "./pages/Configuration";
import Maintenance from "./pages/Maintenance";

function App() {
    return (
        <Router basename="/">
            <ConfiguratorProvider>
                <ToastContainer
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="colored"
                />
                <Routes>
                    <Route element={<MainLayout/>}>
                        <Route path="/" element={<Home/>}/>
                        <Route path="/thank-you" element={<ThankYouPage/>}/>
                        <Route path="/configuration" element={<Configuration/>}/>
                        <Route path="/login" element={<Login/>}/>
                        <Route
                            path="/dealer/:dealerUuid"
                            element={<DealerConfiguration/>}
                        />
                        <Route path="/dealer/:dealerUuid/thank-you" element={<ThankYouPage/>}/>
                    </Route>
                    <Route path="/maintenance" element={<Maintenance/>}/>
                </Routes>
            </ConfiguratorProvider>
        </Router>
    );
}

export default App;
